<template>
  <nav id="sidebar">
      <div class="sidebar-content">
          <div class="content-header content-header-fullrow px-15 bg-black-op-10">
              <div class="content-header-section sidebar-mini-visible-b">
                  <span class="content-header-item font-w700 font-size-xl float-left animated fadeIn">
                      <span class="text-dual-primary-dark">D</span><span class="text-primary">S</span>
                  </span>
              </div>

              <div class="content-header-section text-center align-parent sidebar-mini-hidden">
                  <button type="button" class="btn btn-circle btn-dual-secondary d-lg-none align-v-r" @click="sidebar_close">
                      <i class="fa fa-times text-danger"></i>
                  </button>

                  <div class="content-header-item">
                      <router-link :to="{ name: 'home' }" class="font-w700">
                          <span class="font-size-xl text-dual-primary-dark logo-font">Debt</span>
                          <span class="font-size-xl text-primary logo-font">Ster</span>
                      </router-link>
                  </div>
              </div>
          </div>

          <div class="content-side content-side-full">
              <ul class="nav-main">
                  <li>
                      <router-link :to="{ name: 'admin' }" active-class="active" exact>
                        <i class="si si-cup"></i><span class="sidebar-mini-hide">{{ $t('app.dashboard') }}</span>
                      </router-link>
                  </li>
                  <li class="nav-main-heading"><span class="sidebar-mini-hidden">Работа</span></li>
                  <li v-if="permissions.indexOf('read-debtors') != -1">
                      <router-link :to="{ name: 'adminDebtors' }" active-class="active" >
                        <i class="fa fa-users"></i>
                        <span class="sidebar-mini-hide">{{ $t('debtors.index') }}</span>
                      </router-link>
                  </li>
                  <li v-if="permissions.indexOf('read-debts') != -1">
                      <router-link :to="{ name: 'adminDebts' }" active-class="active" >
                        <i><font-awesome-icon icon="file-contract" /></i>
                        <span class="sidebar-mini-hide">{{ $t('debts.index') }}</span>
                      </router-link>
                  </li>
                  <li>
                      <router-link :to="{ name: 'adminStats' }" active-class="active" >
                        <i class="fa fa-bar-chart"></i>
                        <span class="sidebar-mini-hide">{{ $t('app.stats') }}</span>
                      </router-link>
                  </li>
                  <li v-if="permissions.indexOf('read-debt-tasks') != -1">
                      <router-link :to="{ name: 'adminDebtTasks' }" active-class="active" >
                        <i class="fa fa-calendar-check-o"></i>
                        <span class="sidebar-mini-hide">{{ $t('app.tasks') }}</span>
                      </router-link>
                  </li>
                  <li v-if="permissions.indexOf('read-payments') != -1">
                      <router-link :to="{ name: 'adminPayments' }" active-class="active" >
                        <i class="si si-wallet"></i>
                        <span class="sidebar-mini-hide">{{ $t('payments.index') }}</span>
                      </router-link>
                  </li>
                  <li v-if="permissions.indexOf('read-debtor-calls') != -1 || permissions.indexOf('read-contactface-calls') != -1">
                      <a class="nav-submenu" data-toggle="nav-submenu" href="#">
                          <i><font-awesome-icon icon="phone-alt" /></i>
                          <span class="sidebar-mini-hide">{{ $t('calls.index') }}</span>
                      </a>
                      <ul>
                          <li v-if="permissions.indexOf('read-debtor-calls') != -1">
                            <router-link :to="{ name: 'adminDebtorCalls' }" active-class="active" >
                              {{ $t('calls.debtors') }}
                            </router-link>
                          </li>
                          <li v-if="permissions.indexOf('read-contactface-calls') != -1">
                            <router-link :to="{ name: 'adminContactfaceCalls' }" active-class="active" >
                              {{ $t('calls.contactfaces') }}
                            </router-link>
                          </li>
                      </ul>
                  </li>
                  <li v-if="permissions.indexOf('read-debtor-departures') != -1 || permissions.indexOf('read-contactface-departures') != -1">
                      <a class="nav-submenu" data-toggle="nav-submenu" href="#">
                          <i><font-awesome-icon icon="running" /></i>
                          <span class="sidebar-mini-hide">{{ $t('departures.index') }}</span>
                      </a>
                      <ul>
                          <li v-if="permissions.indexOf('read-debtor-departures') != -1">
                            <router-link :to="{ name: 'adminDebtorDepartures' }" active-class="active" >
                              {{ $t('departures.debtors') }}
                            </router-link>
                          </li>
                          <li v-if="permissions.indexOf('read-contactface-departures') != -1">
                            <router-link :to="{ name: 'adminContactfaceDepartures' }" active-class="active" >
                              {{ $t('departures.contactfaces') }}
                            </router-link>
                          </li>
                      </ul>
                  </li>

                  <li class="nav-main-heading" v-if="permissions.indexOf('export-debts') != -1 || permissions.indexOf('export-payments') != -1 || permissions.indexOf('export-calls') != -1 || permissions.indexOf('read-imports') != -1">
                    <span class="sidebar-mini-hidden">{{ $t('app.import_and_export') }}</span>
                  </li>
                  <li v-if="permissions.indexOf('read-imports') != -1">
                      <router-link :to="{ name: 'adminImport' }" active-class="active" >
                        <i><font-awesome-icon icon="file-upload" /></i>
                        <span class="sidebar-mini-hide">{{ $t('app.import') }}</span>
                      </router-link>
                  </li>
                  <li v-if="permissions.indexOf('export-debts') != -1 || permissions.indexOf('export-payments') != -1 || permissions.indexOf('export-calls') != -1">
                      <router-link :to="{ name: 'adminExport' }" active-class="active" >
                        <i><font-awesome-icon icon="file-download" /></i>
                        <span class="sidebar-mini-hide">{{ $t('app.export') }}</span>
                      </router-link>
                  </li>
                  <li v-if="permissions.indexOf('read-imports') != -1">
                      <router-link :to="{ name: 'adminDocsImport' }" active-class="active" >
                        <i><font-awesome-icon :icon="['far','file-alt']" /></i>
                        <span class="sidebar-mini-hide">{{ $t('app.docs') }}</span>
                      </router-link>
                  </li>


                  <li class="nav-main-heading">
                    <span class="sidebar-mini-hidden">
                      {{ $t('app.control') }}
                    </span>
                  </li>
                  <li v-if="permissions.indexOf('read-users') != -1">
                      <router-link :to="{ name: 'adminUsers' }" active-class="active" >
                        <i class="si si-user"></i>
                        <span class="sidebar-mini-hide">{{ $t('users.index') }}</span>
                      </router-link>
                  </li>
                  <li v-if="permissions.indexOf('read-teams') != -1">
                      <router-link :to="{ name: 'adminTeams' }" active-class="active" >
                        <i class="si si-energy"></i>
                        <span class="sidebar-mini-hide">{{ $t('teams.index') }}</span>
                      </router-link>
                  </li>
                  <li v-if="permissions.indexOf('read-contragents') != -1">
                      <router-link :to="{ name: 'adminContragents' }" active-class="active" >
                        <i><font-awesome-icon icon="university" /></i>
                        <span class="sidebar-mini-hide">{{ $t('contragents.index') }}</span>
                      </router-link>
                  </li>
                  <li v-if="permissions.indexOf('read-acl') != -1">
                      <router-link :to="{ name: 'adminRoles' }" active-class="active" >
                        <i><font-awesome-icon  :icon="['fab','black-tie']" /></i>
                        <span class="sidebar-mini-hide">{{ $t('roles.index') }}</span>
                      </router-link>
                  </li>
                  <li>
                      <a class="nav-submenu" data-toggle="nav-submenu" href="#">
                        <i><font-awesome-icon icon="list-ol" /></i>
                        <span class="sidebar-mini-hide">{{ $t('options.index') }}</span>
                      </a>
                      <ul>
                          <li>
                              <a class="nav-submenu" data-toggle="nav-submenu" href="#">{{ $t('options.statuses') }}</a>
                              <ul>
                                  <li>
                                    <router-link :to="{ name: 'adminOptionDebtStatuses' }" active-class="active" >
                                      {{ $t('options.debt_statuses') }}
                                    </router-link>
                                  </li>
                                  <li>
                                    <router-link :to="{ name: 'adminOptionCallStatuses' }" active-class="active" >
                                      {{ $t('options.call_statuses') }}
                                    </router-link>
                                  </li>
                                  <li>
                                    <router-link :to="{ name: 'adminOptionDepartureStatuses' }" active-class="active" >
                                      {{ $t('options.departure_statuses') }}
                                    </router-link>
                                  </li>
                              </ul>
                          </li>
                          <li>
                              <a class="nav-submenu" data-toggle="nav-submenu" href="#">{{ $t('options.types') }}</a>
                              <ul>
                                  <li>
                                    <router-link :to="{ name: 'adminOptionContactfaceTypes' }" active-class="active" >
                                      {{ $t('options.contactface_types') }}
                                    </router-link>
                                  </li>
                                  <li>
                                    <router-link :to="{ name: 'adminOptionCallTypes' }" active-class="active" >
                                      {{ $t('options.call_types') }}
                                    </router-link>
                                  </li>
                                  <li>
                                    <router-link :to="{ name: 'adminOptionPhoneTypes' }" active-class="active" >
                                      {{ $t('options.phone_types') }}
                                    </router-link>
                                  </li>
                                  <li>
                                    <router-link :to="{ name: 'adminOptionAddressTypes' }" active-class="active" >
                                      {{ $t('options.address_types') }}
                                    </router-link>
                                  </li>
                              </ul>
                          </li>
                      </ul>
                  </li>
                  <li class="nav-main-heading" v-if="permissions.indexOf('read-whitelistip') != -1">
                    <span class="sidebar-mini-hidden">{{ $t('app.index') }}</span>
                  </li>
                  <li v-if="permissions.indexOf('read-whitelistip') != -1">
                    <router-link :to="{ name: 'adminWhitelistip' }" active-class="active" >
                      <i><font-awesome-icon  icon="shield-alt" /></i>
                      <span class="sidebar-mini-hide">{{ $t('whitelistip.index') }}</span>
                    </router-link>
                  </li>
              </ul>
          </div>
      </div>
  </nav>
</template>

<script>
import SimpleBar from 'simplebar';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'permissions',
    ]),
  },
  mounted() {
    window.jQuery('#page-container').off('click.cb.menu');
    window.jQuery('#page-container').on('click.cb.menu', '[data-toggle="nav-submenu"]', (e) => {
      const link = window.jQuery(e.currentTarget);
      const parentLi = link.parent('li');

      if (parentLi.hasClass('open')) {
        parentLi.removeClass('open');
      } else {
        link.closest('ul').children('li').removeClass('open');
        parentLi.addClass('open');
      }

      if (window.jQuery('html').hasClass('no-focus')) {
        link.blur();
      }
      return false;
    });

    let lSidebarScroll = false;
    let lSideOverlayScroll = false;
    if (window.jQuery('#page-container').hasClass('side-scroll')) {
      if ((window.jQuery('#sidebar').length > 0) && !lSidebarScroll) {
        lSidebarScroll = new SimpleBar(window.jQuery('#sidebar')[0]);
      }

      if ((window.jQuery('#side-overlay').length > 0) && !lSideOverlayScroll) {
        lSideOverlayScroll = new SimpleBar(window.jQuery('#side-overlay')[0]);
      }
    } else {
      if (window.jQuery('#sidebar') && lSidebarScroll) {
        lSidebarScroll.unMount();
        lSidebarScroll = null;
        window.jQuery('#sidebar').removeAttr('data-simplebar')
          .html(window.jQuery('.simplebar-content', window.jQuery('#sidebar')).html());
      }
      if (window.jQuery('#side-overlay') && lSideOverlayScroll) {
        lSideOverlayScroll.unMount();
        lSideOverlayScroll = null;

        window.jQuery('#side-overlay').removeAttr('data-simplebar')
          .html(window.jQuery('.simplebar-content', window.jQuery('#side-overlay')).html());
      }
    }
  },
};
</script>
